import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAssignable)?_c(VBtn,{staticClass:"mr-1",attrs:{"icon":"","x-small":"","color":"primary"},on:{"click":_vm.assignCard}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(" mdi-clipboard-arrow-left ")])],1):_vm._e(),_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({style:({ color: _vm.KPONumberColor })},on),[_vm._v(_vm._s(_vm.value !== '-' ? ((_vm.value.slice(0, 10)) + "...") : _vm.value))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.value))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }